import ApiService from '../Services/ApiService';
import useLogout from '../Services/_LogoutService';
import Cookies from 'js-cookie';

const useValidateUserAuth0Handler = () => {
    const { REACT_APP_APILOGIN } = process.env;
    const handleLogout = useLogout();
    const validateUser = (returnCallback = process.env.REACT_APP_MYACCOUNT) => {
        const headers = {
            'Content-Type': 'application/json',
            'X-Token': Cookies.get('token'),
            'X-Value': Cookies.get('xvalue')
        };
        ApiService.getWithHeaders(
            `${REACT_APP_APILOGIN}Auth0/ValidateUserAuth0`, headers)
            .then(async (response) => {
                if (response?.code === "0000") {
                    window.location.href = `${returnCallback}`;
                }
                else {
                    throw new Error(response.message);
                }
            })
            .catch(() => {
                handleLogout();
            });

    };
    return [validateUser]
}
export default useValidateUserAuth0Handler;